import { setStats } from '../../actions/statsSection';
import { getCommonSectionInitActions } from './common';

export function getStatsSectionInitActions(responseData, requestParams) {
  return [
    ...getCommonSectionInitActions(responseData, requestParams, 'stats'),
    setStats(responseData.pageExtraData.detailedStats),
  ].filter(action => action);
}
